/**
 * ══════════════════════════════════════════════════════════════════════
 *  ULTRA PREMIUM NOTIFICATIONS — upn-premium.js  v7.0  (SaaS MAX)
 * ══════════════════════════════════════════════════════════════════════
 */
;(function (w, d) {
  'use strict';

  /* ═══════════════ DATA POOLS ════════════════ */
  var NAMES = [
    'Priya Sharma','Rahul Verma','Anjali Singh','Vikas Gupta','Sunita Yadav','Amit Kumar',
    'Pooja Pandey','Ravi Mishra','Neha Srivastava','Sanjay Tiwari','Rekha Chauhan',
    'Deepak Joshi','Seema Agarwal','Manoj Saxena','Komal Dubey','Sneha Patil','Aarav Desai',
    'Meghna Kulkarni','Suresh Jadhav','Anita Shinde','Disha Patel','Hardik Shah','Riya Mehta',
    'Chirag Trivedi','Riddhi Joshi','Kavya Rathore','Arjun Singhvi','Payal Choudhary',
    'Manish Sharma','Priyanka Jain','Swapnil Bhosale','Shweta More','Nilesh Salunkhe',
    'Tejal Gaikwad','Amol Pawar','Vaishali Kadam','Sachin Mane','Pradnya Rane',
    'Rohit Bhagat','Sayali Dhole','Gurpreet Kaur','Harjit Singh','Simran Bhatia',
    'Manpreet Gill','Navneet Arora','Jaswinder Singh','Parminder Kaur','Harleen Kaur',
    'Rajveer Singh','Amandeep Kaur','Lovepreet Singh','Navjot Kaur','Daljit Singh',
    'Rupinder Kaur','Kulwinder Singh','Jaspreet Kaur','Paramjit Singh','Gurmeet Singh',
    'Ananya Chatterjee','Subhajit Das','Priyanka Ghosh','Souvik Mukherjee','Payel Bose',
    'Debashis Chakraborty','Moumita Sen','Arnab Roy','Srabanti Dey','Pritam Banerjee',
    'Arpita Sarkar','Soumya Mondal','Tanushree Biswas','Subrata Hazra','Rupa Saha',
    'Nilanjana Pal','Satyajit Bhattacharya','Kamalika Nandi','Bhaskar Ghosh','Rimi Dutta',
    'Kavitha Rajan','Karthik Sundaram','Priya Balaji','Suresh Murugan','Deepa Krishnan',
    'Vignesh Subramanian','Nithya Venkatesh','Ramesh Natarajan','Saranya Anand',
    'Praveen Chandrasekaran','Revathi Ramaswamy','Lavanya Gopalakrishnan',
    'Manikandan Arumugam','Sumathy Ponnusamy','Anand Thyagarajan','Selvam Krishnamurthy',
    'Divya Nair','Arjun Hegde','Pooja Shetty','Rahul Kamath','Sneha Bhat',
    'Arun Menon','Sreelakshmi Pillai','Vishnu Varma','Abhirami Krishnan','Jibin Thomas',
    'Reshma George','Akhil Mohan','Nimisha Chandran','Sreeraj Kumar','Meenakshmi Nambiar',
    'Harikrishnan Unni','Archana Suresh','Pradeep Namboothiri','Vivek Radhakrishnan',
    'Lakshmi Reddy','Venkatesh Naidu','Sravani Rao','Srikanth Varma','Padmaja Devi',
    'Ramakrishna Murthy','Vijayalakshmi Prasad','Subrahmanyam Raju','Chandra Sekhar Babu',
    'Hymavathi Rao','Ravi Shankar Reddy','Venkateswara Rao','Santhisri Naidu',
    'Bhargav Krishna','Annapurna Devi','Yeshwanth Reddy','Madhavi Latha Rao',
    'Rohan Fernandes','Deepika Joshi','Kaveri Naik','Vinod Kulkarni','Preethi Shetty',
    'Sunil Gowda','Lakshmi Iyengar','Manjunath Belur','Vidya Murthy','Raghu Swamy',
    'Savitha Reddy','Venkatesh Mysore','Anitha Bhat','Sunitha Pai','Jayaram Upadhya',
    'Geetha Murali','Prakash Hebbar','Malathi Rao','Basavaraju Patil',
    'Meera Agarwal','Gaurav Yadav','Tanvi Bhatt','Karan Malhotra','Swati Jain',
    'Nikhil Thakur','Palak Saxena','Harsh Dubey','Shivani Rao','Aman Khanna',
    'Ritika Sharma','Siddharth Gupta','Nandini Mishra','Abhishek Tripathi','Prachi Verma',
    'Yash Shukla','Divyanka Tiwari','Raghav Agarwal','Sakshi Pandey','Kartik Dubey',
    'Vishal Jain','Sonam Yadav','Akash Soni','Sumit Sharma','Renu Agarwal',
    'Sunil Kumar','Preeti Verma','Devendra Singh','Kanchan Mishra',
    'Ankita Patel','Piyush Jain','Ruchi Soni','Tarun Tiwari','Madhuri Nayak',
    'Parth Shah','Nisha Patel','Dhruv Mehta','Mira Bhatt','Jigar Patel',
    'Heena Shah','Krunal Mehta','Pooja Thakkar','Bhavesh Patel','Foram Shah',
    'Vipul Jain','Khyati Trivedi','Darshan Patel','Meet Adesara',
    'Ritu Kumari','Saurabh Kumar','Anita Devi','Rajesh Pandey','Savita Singh',
    'Smita Patra','Subrat Mohanty','Lipika Behera','Prasant Nayak','Sasmita Dash',
    'Priyanka Borah','Rajib Saikia','Bhaskar Baruah','Dipali Kalita','Mitu Devi',
    'Aryan Kapoor','Mehak Malhotra','Vikram Sood','Sunaina Luthra','Rohit Bhatia',
    'Neetu Dagar','Sumit Hooda','Harish Rana','Kavita Sangwan','Sachin Negi',
    'Natasha Fernandes','Derick DSouza','Alicia Pereira','Mathew Mascarenhas',
    'Anil Thakur','Manju Devi','Surender Chauhan','Kamla Rawat','Vikash Negi',
    'Ramesh Sahu','Pushpa Yadav','Yogesh Chandrakar','Santosh Patel',
    'Ishaan Chawla','Kiara Patel','Vedant Sharma','Zara Malhotra','Dhruv Kapoor',
    'Avni Singh','Reyansh Gupta','Myra Joshi','Arnav Mehta','Piya Desai',
    'Kabir Khanna','Tara Nair','Vihaan Roy','Anvi Reddy','Rayan Shah',
    'Navya Pillai','Aditya Iyer','Saanvi Kulkarni','Atharv Patil','Ira Bhatt',
    'Shaan Trivedi','Mahi Sinha','Aryan Verma','Nisha Pandey','Om Joshi',
    'Sia Sharma','Dev Rao','Kiya Agarwal','Veer Singh','Reet Kaur',
    'Zain Khan','Sara Ansari','Armaan Shaikh','Aliya Pathan','Farhan Qureshi',
    'Nida Mirza','Imran Siddiqui','Sana Malik','Junaid Ahmed','Ruksana Begum',
    'Aditi Bhardwaj','Shreya Kapoor','Kunal Desai','Payal Shah','Mihir Mehta',
    'Tejal Patel','Smriti Joshi','Rohit Sharma','Kajal Singh','Vivek Gupta',
    'Pooja Kumari','Aakash Verma','Deepti Mishra','Ajay Pandey','Kavita Yadav',
    'Sonia Rawat','Naresh Sharma','Priti Patel','Bhavesh Jain','Khushbu Shah',
    'Tushar Mehta','Ami Trivedi','Neel Desai','Rupal Shah','Yash Patel',
    'Monika Gupta','Sagar Sharma','Swapna Nair','Bipin Thomas','Liji Mathew',
    'Sonu Kumar','Guddu Sharma','Bablu Yadav','Pinki Devi','Sundar Rajan',
    'Nalini Krishnan','Bharathi Suresh','Murugan Shanmugam','Geetha Lakshmi',
    'Chandran Pillai','Thankam Nair','Rajan Menon','Ambika Devi','Krishnakumar',
    'Hemant Tiwari','Madhu Sharma','Girish Pandey','Sunita Mishra','Arun Kumar',
    'Sandeep Yadav','Rekha Singh','Vinay Shukla','Radha Pandey','Ashish Gupta',
    'Babita Sharma','Mukesh Patel','Sunita Joshi','Ranjit Singh','Kamini Devi',
    'Pintu Sharma','Sanjana Patel','Rahul Joshi','Anuja Desai','Himanshu Trivedi'
  ];

  var FEMALE_SET = new Set([
    'priya','pooja','sneha','neha','anita','kavita','sunita','rekha','seema','komal',
    'disha','riya','kavya','payal','nisha','gurpreet','simran','manpreet','harleen',
    'amandeep','jaspreet','rupinder','parminder','navjot','gurmeet','ananya','priyanka',
    'payel','moumita','srabanti','arpita','tanushree','rupa','nilanjana','kamalika',
    'rimi','kavitha','nithya','saranya','revathi','lavanya','sumathy','padmaja',
    'vijayalakshmi','santhisri','hymavathi','madhavi','annapurna','divya','abhirami',
    'nimisha','meenakshmi','archana','sreelakshmi','reshma','lakshmi','sravani',
    'deepika','kaveri','preethi','vidya','savitha','anitha','sunitha','geetha',
    'malathi','meera','tanvi','swati','palak','shivani','ritika','nandini','prachi',
    'divyanka','sakshi','sonam','renu','preeti','kanchan','ankita','ruchi','nisha',
    'mira','heena','foram','khyati','riddhi','ritu','savita','smita','lipika',
    'sasmita','dipali','mitu','mehak','sunaina','neetu','kavita','shweta','natasha',
    'alicia','manju','kamla','pushpa','kiara','avni','myra','piya','tara','anvi',
    'navya','saanvi','ira','mahi','reet','kiya','sia','sara','aliya','nida','sana',
    'ruksana','zara','aditi','shreya','payal','tejal','smriti','kajal','deepti',
    'kavita','sonia','priti','khushbu','ami','rupal','monika','swapna','liji','pinki',
    'nalini','bharathi','geetha','thankam','ambika','madhu','sunita','rekha','radha',
    'babita','kamini','sanjana','anuja','himanshu'
  ]);

  var CITIES = [
    'Mumbai, Maharashtra','Pune, Maharashtra','Nagpur, Maharashtra','Thane, Maharashtra',
    'Nashik, Maharashtra','Aurangabad, Maharashtra','Solapur, Maharashtra',
    'New Delhi','Noida, UP','Gurugram, Haryana','Ghaziabad, UP','Faridabad, Haryana',
    'Lucknow, UP','Kanpur, UP','Agra, UP','Varanasi, UP','Prayagraj, UP','Meerut, UP',
    'Jaipur, Rajasthan','Jodhpur, Rajasthan','Udaipur, Rajasthan','Kota, Rajasthan',
    'Ahmedabad, Gujarat','Surat, Gujarat','Vadodara, Gujarat','Rajkot, Gujarat',
    'Bhavnagar, Gujarat','Gandhinagar, Gujarat',
    'Bengaluru, Karnataka','Mysuru, Karnataka','Mangaluru, Karnataka','Hubli, Karnataka',
    'Chennai, Tamil Nadu','Coimbatore, TN','Madurai, TN','Salem, TN','Trichy, TN',
    'Hyderabad, Telangana','Warangal, TS','Vijayawada, AP','Visakhapatnam, AP',
    'Kolkata, West Bengal','Howrah, WB','Siliguri, WB','Durgapur, WB',
    'Kochi, Kerala','Thiruvananthapuram, Kerala','Kozhikode, Kerala','Thrissur, Kerala',
    'Bhopal, MP','Indore, MP','Jabalpur, MP','Gwalior, MP','Ujjain, MP',
    'Chandigarh','Ludhiana, Punjab','Amritsar, Punjab','Jalandhar, Punjab','Patiala, Punjab',
    'Patna, Bihar','Gaya, Bihar','Muzaffarpur, Bihar','Bhagalpur, Bihar',
    'Ranchi, Jharkhand','Jamshedpur, JH','Dhanbad, JH',
    'Bhubaneswar, Odisha','Cuttack, Odisha','Sambalpur, Odisha',
    'Raipur, CG','Bilaspur, CG',
    'Guwahati, Assam','Dibrugarh, Assam',
    'Dehradun, Uttarakhand','Haridwar, Uttarakhand',
    'Shimla, HP','Manali, HP','Dharamshala, HP',
    'Panaji, Goa','Margao, Goa',
    'Puducherry','Agartala, Tripura','Shillong, Meghalaya',
    'Gangtok, Sikkim','Jammu, J&K','Srinagar, J&K'
  ];

  var ACTIONS_HI = [
    'ne abhi yeh kharida! 🛒','ne order place kiya ✅','ne yeh item liya 🎉',
    'ne cart mein daala aur checkout kiya 🚀','ne abhi purchase complete ki 💳',
    'ne order confirm kiya 📦','ne nayi order lagayi ⚡','ne yeh item secure kar liya 🔒',
    'ne pasand karke turant order kiya ❤️','ne 5 star dekar dobara order kiya ⭐',
    'ne dosto ko bhi recommend kiya 👥','ne reviews padh ke khareeda 📖',
    'ne last piece grab kar liya ⏰','ne sale mein yeh liya 💰',
    'ne doosri baar order kiya 🔁','ne gift ke liye order kiya 🎁',
    'ne express delivery ke saath order kiya ⚡📦','ne reorder kiya — ruk nahi saka! 🔥',
    'ne wishlist se finally order kiya 💝','ne midnight sale mein grab kiya 🌙',
    'ne COD choose karke order kiya 💵','ne same day delivery select ki 🚀',
    'ne EMI pe smart order kiya 💳','ne unboxing video dekh ke order kiya 🎬'
  ];

  var ACTIONS_EN = [
    'just purchased this! 🛒','placed an order ✅','grabbed this item 🎉',
    'checked out successfully 🚀','completed their purchase 💳',
    'confirmed their order 📦','secured the last one! ⏰','ordered for the family 👨‍👩‍👧',
    'reordered — loved it! 🔁','gifted this to someone special 🎁',
    'got this on sale 💰','ordered after reading reviews 📖',
    'upgraded their order with this 🎯','snagged this deal 🏆',
    'ordered with same day delivery ⚡','finally hit buy! 💝'
  ];

  var COMMENTS_HI = [
    '"Ekdum mast product hai bhai! 🔥 Quality dekh ke dil khush ho gaya. Totally worth it! 💯"',
    '"Bahut zyada achha nikla — expected se bhi better! 😍 Highly recommend karunga!"',
    '"Quality top-notch hai ✅ Paise wasool, bilkul sahi decision tha. 💪"',
    '"Sach mein bahut premium feel aata hai 👌 5 stars deserve karta hai! ⭐⭐⭐⭐⭐"',
    '"Super fast delivery! 🚀 2 din mein ghar aa gaya — packaging bhi solid! 📦"',
    '"Is price mein itna achha product? Genuinely shocked! 😮 Best deal on the market! 🏆"',
    '"Value for money ekdum! 💎 Itne mein aisa kahin nahi milega. Love it! ❤️"',
    '"Pehle doubt tha, par order karne ke baad sab clear! ✅ 100% Trustworthy! 🙌"',
    '"Itna achha experience ki phir se order kar liya 🔄 Addicted ho gaya yaar!"',
    '"Gift ke liye order kiya tha 🎁 Unhe bahut pasand aaya! Packaging bhi gift-ready! 🎀"',
    '"Yeh mera teesra order hai is store se 🔁 Har baar same great quality! 💪⭐"',
    '"Regular customer ban gaya hoon — quality aur service pe full bharosa! ❤️ 🙏"',
    '"Wow! Literally wow 🤩 Photos se bhi zyada sundar lagta hai real mein!"',
    '"Khol ke dekha toh dil khush! ✨ Premium unboxing experience tha! 🎊"',
    '"Bilkul aise hi chahiye tha — perfect fit, great quality! 💯 Will buy again!"',
    '"Order ke 2 din baad hi aa gaya! 😱 Packaging ekdum safe tha! 📦✅"',
    '"Mere husband ne bhi order kiya — dono bahut khush hain! 👫❤️ Couple goals!"',
    '"Bohot dino se soch raha tha, finally order kiya — koi pachtawa nahi! 🙏 Superb!"',
    '"Price pe mat jao, quality dekho! 💎 Is price mein itna — genuinely amazed! 😲"',
    '"Sab doston ko recommend kiya — 4 logo ne order kiya mere kehne pe! 👏 Viral!"',
    '"Discount mein bhi itni quality? Yeh toh chori hai bhai! 😂🔥 Jaldi order karo!"',
    '"Review padh ke order kiya tha — reviews sach nikle! 📝✅ Exactly as described!"',
    '"5 baar site pe ghuma, finally cart mein daala — ab koi regret nahi! 🛒💯"',
    '"Meri beti ne suggest kiya — Maine order kiya aur woh sahi nikli! 👧❤️ Great!"',
    '"Ye product ne dil jeet liya! 🏆 Quality, packaging, delivery — sab A1! ⭐"',
    '"Office mein dikhaaya — sab ne poocha kahan se liya 😎 Now they all want one!"',
    '"Return bhi nahi karna pada — pehli baar itna satisfied hoon! 😊✅ Zero regrets!"',
    '"COD pe order kiya — delivery boy bahut polite tha 🙏 Overall great experience!"',
    '"EMI mein le liya aur quality dekh ke koi pachtawa nahi! 💳🔥 Smart shopping!"',
    '"Yeh wala product hata mat dena — mujhe baar baar chahiye! 🔁❤️ Permanent fav!"',
    '"Midnight sale mein order kiya 🌙 Neend bhi sacrifice ki — worth it! 💫"',
    '"Unboxing ka video banaya — friends bhi order karne lage! 🎬📱 Spread the love!"',
    '"Diwali gift ke liye perfect! 🪔🎁 Sab ghar mein khush ho gaye!"',
    '"Birthday pe wife ko surprise diya — usne toh thank you hi bolti rahi! 💕🎂"',
    '"Photos isse bhi achha lagta hai real mein! Camera justice nahi karta! 📸😍"',
    '"Free gift bhi aaya saath mein 🎁 Unexpected surprise! Bahut achha laga! ✨"',
    '"Customer service ne bhi help ki — query ka jawab 5 min mein! 🤩 Impressed!"',
    '"Main toh fan ho gaya is brand ka! 🏆 Baaki sab brands alag lagte hain ab!"',
    '"Washing ke baad bhi quality same rahi! 🧺✅ Durability top class hai bhai!"',
    '"Color exactly wahi tha jo photo mein dikhta tha! 🎨👌 No colour difference!"',
    '"Size guide bilkul sahi tha! 📏✅ Perfect fit — no return needed! Saved time!"',
    '"3 different items order kiye — teeno perfect! 🎯 Consistency amazing hai! 🌟"',
    '"Ghar mein sab ne tariff ki! 👨‍👩‍👧‍👦🏆 Ab sab order karna chahte hain! 😄"',
    '"Packaging itni achi thi ki box bhi rakh liya! 📦🥰 Aesthetic level: 100! 💅"',
    '"Anniversary gift ke liye perfect! 💑🎁 Partner ne dekh ke muskura diya! 😊"',
    '"Instagram pe dekha — order kiya — real mein aur bhi better! 📱➡️🤩"',
    '"Student hoon, budget kam — lekin quality se compromise nahi karna tha! ✅💪"',
    '"Mummy ke liye order kiya tha — woh toh bohot khush hain! 👩❤️ Best gift ever!"',
    '"Eco-friendly packaging tha! 🌿♻️ Environment ke liye bhi sahi! Proud! 💚"',
    '"10 saal baad phir is brand pe wapas aaya — quality unchanged! 👏 Legend brand!"',
    '"Flash sale mein 2 second mein cart mein dala! ⚡🏃 Speed shopping champion! 😂"',
    '"5 members ke liye 5 alag colors — sab khush! 🌈👨‍👩‍👧‍👦 Family happiness! ❤️"',
    '"App pe order kiya — experience desktop se bhi smooth tha! 📱💨 App amazing! 🚀"',
    '"Limited edition tha — pakad liya jaldi! 🏃💨 Glad I did not wait! Smart! 💯"',
    '"Holi pe use kiya — quality barkaraar rahi! 🎨🌈 Durable AF! 5 stars! ⭐⭐⭐⭐⭐"',
    '"Yeh mera 10th order hai is store pe! 🎯 Loyal customer hoon main! 👑 Proud!"',
    '"Warranty card bhi aaya saath mein! 🛡️📄 Professional touch! Very impressed! ✅"',
    '"Cash back bhi mila! 💰🎉 Effectively free mein aa gaya! Smart shopping win! 🏆"',
    '"Made in India label dekh ke aur khushi hui! 🇮🇳🏭 Vocal for local! 💪 Proud!"',
    '"Bulk order kiya 10 pieces — corporate gifting ke liye! 🏢🎁 Professional choice!"',
    '"Review video upload karwane ki request aayi — zaroor karenge! 🎬📱 Engaged fan!"',
    '"Packing ekdum tight aur safe thi — zero damage! 📦💎 Packaging quality 10/10!"',
    '"WhatsApp pe order update aata raha — very convenient! 💬📱 Modern service! 😊"',
    '"Pooja ke liye order kiya — bilkul perfect aur shubh! 🙏✨ Blessings with it!"',
    '"Ghar shift karte waqt order kiya — new house new things! 🏠🎉 New chapter! ✨"',
    '"Return process bhi try kiya (wrong size) — bahut easy tha! 🔄✅ Stress-free! 😊"',
    '"Har mahine ek naya product try karta hoon is store se! 📅🛍️ Exploration mode! 🌟"',
    '"Dost ke ghar pe dekha — immediately order kar liya! 👀🛒 Impulse buy, zero regret!"',
    '"Summer sale mein 40% off! ☀️💸 Best investment of the season! 🏆 So happy!"',
    '"Night 2 baje order kiya — subah 6 baje confirm email aaya! 🌙➡️🌅 24/7 service!"',
    '"Yeh brand ab meri first choice — sab kuch isi se order karta hoon! 👑❤️ Loyalty!"',
    '"Friends ne notice kiya pockets mein — poocha kahan se liya! 😎🔥 Trend setter!"',
    '"Meri wish list mein tha 2 saal se — finally khareed liya! 💝🛒 Dreams come true! ✅"',
    '"Saal mein doosri baar order kar raha hoon — loyalty prove! 🔁❤️ Permanent fan! 👑"',
    '"Video call pe dost ko dikhaaya — usne turant order kar diya! 😂📱 Viral product!"',
    '"Paas ke shop mein nahi mila — online order kiya — bahut convenient! 📱🏠 Digital!"',
    '"Pre-order kiya tha — jab aaya toh overwhelmed ho gaya! 🎁🥺 Patience rewarded! 💝"',
    '"Promotion pe khud ko gift diya! 👔🎁 Self-reward well deserved! 💪🎊 Treated self!"',
    '"Bhai ko rakhi gift diya — usne bhi order kar liya apne liye! 😄👫 Brother love! ❤️"',
    '"Newly married hoon — ghar ke liye best purchase! 🏠💕 Highly recommend to all!"',
    '"Travel mein use kiya — compact aur sturdy! ✈️💼 Perfect travel companion! 🌍"',
    '"Office snacks ke liye order kiya — team ne 1 ghante mein khatam! 😋🎉 Team fav!"',
    '"Senior citizen hoon, online first time order kiya — bahut smooth tha! 🙏😊 Easy!"',
    '"Repeat purchase — yeh toh monthly routine ban gaya hai! 📅🔁 Monthly essential! 💯"',
    '"Festive season mein order kiya — delivery on time! 🎆📦 Stress-free Diwali! 🪔"',
    '"Naani ne bola achha hai — naani ka taste toh perfect hota hai na! 👵❤️ Trusted! 😄"',
    '"Pehle duplicate liya tha — is baar genuine mila! 😤➡️😍 Quality difference clear! ✅"',
    '"10th floor pe delivery kiya — delivery person ne bina complaint ke! 💪🙏 Dedicated!"',
    '"3 products compare kiya — yahi best value mila! ⚖️💰 Smart purchase decision! 💡"',
    '"App notification se pata chala stock low hai — turant order kiya! 🔔⚡ Alert smart!"',
    '"Zero scratches, perfect condition mein mila! 📦💎 Packing quality absolutely excellent!"',
    '"Ek ghante mein order confirm hua! ⏱️✅ Fastest I have experienced! Very impressed! 🤩"',
    '"Bimari mein order kiya — delivery ne mood acha kar diya! 🤒➡️😊 Healing therapy! 💊"',
    '"International quality product — export level! 🌍⭐ India pe proud! 🇮🇳 Jai Hind!"',
    '"Referral link use kiya — dono ko discount! 🤝💸 Win-win situation! 🎊 Best deal!"',
    '"Pehli baar is website se order — experience ne loyal bana diya! ❤️🔁 New regular!"',
    '"Handmade feel hai product mein! 🤲✨ Artisanal quality — worth every single rupee!"',
    '"Hamara pura mohalla order kar raha hai ab! 🏘️😊 Community favourite ban gaya! 🌟"',
    '"Dussehra pe order kiya — bohot badhiya festive packaging thi! 🎆🎁 Festive vibes! 🎊"',
    '"Mother\'s Day gift ke liye — maa ne dekh ke aansu aa gaye khushi ke! 👩❤️ Priceless! 💝"',
    '"Teacher ne recommend kiya tha class mein — aur sach mein kaam ka nikla! 📚✅ Trusted! 🎓"',
    '"Gym ke liye perfect choice tha! 💪🏋️ Quality ne workout bhi better bana diya! 🔥"',
    '"Doctors order hai iska — aur results dikhe! 👨‍⚕️✅ Health investment well made! 💊"',
    '"Neighbours dekh ke impressed ho gaye — 3 families ne order kar liya! 🏘️👏 Block fav! 🌟"',
    '"5 star rating dena toh banta hai — yeh product genuinely usski deserve karta hai! ⭐⭐⭐⭐⭐"',
    '"Bohot badhiya! Ek baar use karo phir iska importance samajh aata hai! 🌟💯 Must buy!"'
  ];

  var COMMENTS_EN = [
    '"Absolutely love this! 🔥 Quality exceeded expectations! Totally worth it! 💯"',
    '"Super fast delivery! 🚀 Came in 2 days — packaging immaculate! 📦 Impressed!"',
    '"Best purchase this year! ⭐ The quality at this price is simply unbeatable! 💎"',
    '"Ordered 3 times already — always the same great quality! 🔁 Loyal for life! ❤️"',
    '"Gave as a gift — they absolutely loved it! 🎁🥰 Would definitely recommend! 👏"',
    '"Exactly as described — no surprises! ✅📝 Reliable and honest seller! 👍"',
    '"Premium feel for a budget price! 💸 Genuinely shocked at the quality! 😮"',
    '"The reviews were right — this is 100% worth every penny! ⭐⭐⭐⭐⭐ Verified!"',
    '"Customer service was amazing — quick response to my query! 🤩 Top notch! 🏆"',
    '"Eco-friendly packaging too! 🌿♻️ Very proud of this sustainable purchase! 💚"',
    '"Limited edition — grabbed before it sold out! ⚡🏃 No regrets whatsoever! ✅"',
    '"Perfect for gifting — beautifully packaged and presented! 🎀✨ Very impressed! 💝"',
    '"5th order from this store — my go-to brand now! 👑❤️ Complete loyalty earned! 🏆"',
    '"Made in India, world class quality! 🇮🇳🌍 Vocal for local and loving it! 💪"',
    '"Trending product — I completely see why now! 📈🔥 Jumped on bandwagon! ✅"',
    '"Photos do not do it justice — even better in real life! 📸➡️🤩 Stunning product!"'
  ];

  var TIMES_HI = [
    'Abhi','30 sec pehle','1 min pehle','2 min pehle','3 min pehle',
    '5 min pehle','8 min pehle','12 min pehle','15 min pehle',
    '20 min pehle','30 min pehle','45 min pehle','1 ghanta pehle'
  ];
  var TIMES_EN = [
    'Just now','30 sec ago','1 min ago','2 min ago','3 min ago','5 min ago',
    '8 min ago','12 min ago','15 min ago','20 min ago','30 min ago',
    '45 min ago','1 hour ago'
  ];

  /* ═══════════════════════════════════════════════════════
     UNIQUE IMAGE ENGINE
  ═══════════════════════════════════════════════════════ */
  function fnv32(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = (h * 16777619) >>> 0;
    }
    return h;
  }

  function isF(name) {
    return FEMALE_SET.has((name || '').split(' ')[0].toLowerCase());
  }

  var AV_COLORS = [
    'FF6B6B','FF8E53','FFC300','2ECC71','1ABC9C','3498DB','9B59B6','E91E63',
    'F39C12','16A085','2980B9','8E44AD','C0392B','27AE60','D35400','1565C0',
    'AD1457','00838F','6A1B9A','558B2F','4527A0','00695C','37474F','BF360C',
    '006064','4A148C','1B5E20','B71C1C','0D47A1','E65100','33691E','880E4F'
  ];

  function getAvatarUrls(name, style) {
    var h = fnv32(name);
    var female = isF(name);
    var slot = (h % 99) + 1;
    var encN = encodeURIComponent(name);
    var color = AV_COLORS[h % AV_COLORS.length];
    var initials = name.split(' ').slice(0,2).map(function(w){ return w[0] || ''; }).join('').toUpperCase();

    if (!style || style === 'realistic_auto' || style === 'realistic_female' || style === 'realistic_male') {
      var g = (style === 'realistic_male') ? false : (style === 'realistic_female') ? true : female;
      return [
        'https://randomuser.me/api/portraits/' + (g ? 'women' : 'men') + '/' + slot + '.jpg',
        'https://ui-avatars.com/api/?name=' + encN + '&size=120&background=' + color + '&color=fff&bold=true&rounded=true&length=2',
        'https://api.dicebear.com/9.x/initials/svg?seed=' + encN + '&backgroundColor=' + color
      ];
    }
    var bases = {
      lorelei:   'https://api.dicebear.com/9.x/lorelei/svg?seed=' + encN + '&backgroundColor=b6e3f4,c0aede,d1d4f9',
      micah:     'https://api.dicebear.com/9.x/micah/svg?seed=' + encN + '&backgroundColor=b6e3f4,c0aede',
      avataaars: 'https://api.dicebear.com/9.x/avataaars/svg?seed=' + encN + '&backgroundColor=b6e3f4,c0aede',
      bottts:    'https://api.dicebear.com/9.x/bottts/svg?seed=' + encN + '&backgroundColor=b6e3f4',
      fun_emoji: 'https://api.dicebear.com/9.x/fun-emoji/svg?seed=' + encN,
      pixel:     'https://api.dicebear.com/9.x/pixel-art/svg?seed=' + encN
    };
    return [
      bases[style] || bases.lorelei,
      'https://ui-avatars.com/api/?name=' + encN + '&size=120&background=' + color + '&color=fff&bold=true&rounded=true'
    ];
  }

  /* ═══════════════ SMART RANDOM ═══════════════ */
  function SR(arr) { this.s=arr.slice(); this.p=[]; this.l=null; this._r(); }
  SR.prototype._r = function() {
    this.p = this.s.slice().sort(function(){ return Math.random()-.5; });
    if (this.p.length>1 && this.p[0]===this.l) { var t=this.p[0]; this.p[0]=this.p[1]; this.p[1]=t; }
  };
  SR.prototype.next = function() { if (!this.p.length) this._r(); return (this.l=this.p.pop()); };

  /* ═══════════════ UTILS ═══════════════ */
  function ri(a,b){ return Math.floor(Math.random()*(b-a+1))+a; }

  function starsHTML(n) {
    var h='';
    for (var i=1;i<=5;i++) h+='<svg class="upn-star" width="12" height="12" viewBox="0 0 24 24" fill="'+(i<=n?'#f59e0b':'none')+'" stroke="#f59e0b" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
    return h;
  }

  function badgeSVG(style, color) {
    var c = color || '#1877F2';
    if (style==='instagram') return '<svg class="upn-verified-svg" width="17" height="17" viewBox="0 0 32 32"><circle cx="16" cy="16" r="16" fill="'+c+'"/><path d="M10 16.5L14 20.5L22 12" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    if (style==='gold') return '<svg class="upn-verified-svg" width="17" height="17" viewBox="0 0 32 32"><circle cx="16" cy="16" r="15" fill="#FFF8E1" stroke="#FFB300" stroke-width="2"/><path d="M16 6L18.5 12.5L25.5 13L20 17.5L21.8 24.5L16 21L10.2 24.5L12 17.5L6.5 13L13.5 12.5Z" fill="#FFB300"/></svg>';
    var uid='u'+Math.abs(fnv32(c)).toString(36).slice(0,6);
    return '<svg class="upn-verified-svg" width="17" height="17" viewBox="0 0 32 32" fill="none"><defs><linearGradient id="'+uid+'" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse"><stop offset="0%" stop-color="#FFD700"/><stop offset="50%" stop-color="#FFA500"/><stop offset="100%" stop-color="#FFD700"/></linearGradient></defs><circle cx="16" cy="16" r="15" fill="white" stroke="url(#'+uid+')" stroke-width="2"/><path d="M16 4L25 8.5V17C25 22 21 26.5 16 28C11 26.5 7 22 7 17V8.5Z" fill="'+c+'"/><path d="M11.5 16.5L14.5 19.5L20.5 13" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function playChime() {
    try {
      var ac=new(w.AudioContext||w.webkitAudioContext)();
      [[880,0],[1100,.08],[1320,.16]].forEach(function(fw){
        var o=ac.createOscillator(),g=ac.createGain();
        o.connect(g);g.connect(ac.destination);
        o.type='sine';o.frequency.value=fw[0];
        g.gain.setValueAtTime(0.18,ac.currentTime+fw[1]);
        g.gain.exponentialRampToValueAtTime(0.001,ac.currentTime+fw[1]+0.25);
        o.start(ac.currentTime+fw[1]);o.stop(ac.currentTime+fw[1]+0.26);
      });
    } catch(e){}
  }

  function injectCSS(id,css){ if(d.getElementById(id)) return; var s=d.createElement('style');s.id=id;s.textContent=css;d.head.appendChild(s); }

  function parseLines(raw, fallback) {
    if (!raw||!raw.length) return fallback;
    var arr=Array.isArray(raw)?raw:[String(raw)];
    var lines=[];
    arr.forEach(function(x){
      String(x||'').split(/\n|<br\s*\/?>/i).forEach(function(l){
        var t=l.replace(/\\n/g,'').trim();
        if(t.length>1) lines.push(t);
      });
    });
    return lines.length?lines:fallback;
  }

  function hasHinglishWords(text) {
    return /\b(log|abhi|dekh|kharida|kiya|liye|liya|pehle|khatam|khareeda|daala|saath)\b/i.test(String(text||''));
  }

  function labelText(raw, englishText, hinglishText, lang) {
    if (lang === 'hinglish') return raw || hinglishText;
    return (!raw || hasHinglishWords(raw)) ? englishText : raw;
  }

  /* ═══════════════ PRESETS ═══════════════ */
  var PRESETS = {
    glass:     {'--upn-bg':'rgba(255,255,255,0.85)','--upn-border':'rgba(255,255,255,0.65)','--upn-shadow':'0 24px 60px rgba(0,0,0,0.15),0 4px 16px rgba(0,0,0,0.08)','--upn-sub':'rgba(15,15,26,0.55)','--upn-badge-bg':'rgba(108,62,255,0.09)','--upn-prog-track':'rgba(108,62,255,0.1)','--upn-comment-bg':'rgba(108,62,255,0.06)','--upn-blur-amount':'28px'},
    dark:      {'--upn-bg':'rgba(10,10,20,0.97)','--upn-text':'#f0f0ff','--upn-border':'rgba(255,255,255,0.07)','--upn-shadow':'0 24px 64px rgba(0,0,0,0.65)','--upn-sub':'rgba(180,180,220,0.55)','--upn-badge-bg':'rgba(108,62,255,0.22)','--upn-prog-track':'rgba(255,255,255,0.07)','--upn-comment-bg':'rgba(255,255,255,0.04)','--upn-blur-amount':'0px'},
    white:     {'--upn-bg':'#ffffff','--upn-border':'#e8e8f2','--upn-shadow':'0 16px 48px rgba(0,0,0,0.1)','--upn-sub':'#64748b','--upn-badge-bg':'#f0eeff','--upn-prog-track':'#f0eeff','--upn-comment-bg':'#f7f5ff','--upn-blur-amount':'0px'},
    gradient:  {'--upn-bg':'linear-gradient(135deg,#ffffff 0%,#f4f0ff 100%)','--upn-border':'#ddd6fe','--upn-shadow':'0 20px 52px rgba(108,62,255,0.18)','--upn-sub':'#7c6eb5','--upn-badge-bg':'#ede9fe','--upn-prog-track':'#ede9fe','--upn-comment-bg':'rgba(108,62,255,0.07)','--upn-blur-amount':'0px'},
    neon:      {'--upn-bg':'rgba(4,4,16,0.97)','--upn-text':'#e0e0ff','--upn-border':'rgba(108,62,255,0.9)','--upn-shadow':'0 0 32px rgba(108,62,255,0.55),0 0 8px rgba(108,62,255,0.3)','--upn-sub':'rgba(160,160,230,0.7)','--upn-badge-bg':'rgba(108,62,255,0.22)','--upn-prog-track':'rgba(108,62,255,0.18)','--upn-comment-bg':'rgba(108,62,255,0.1)','--upn-blur-amount':'0px'},
    minimal:   {'--upn-bg':'#fafafa','--upn-border':'#efefef','--upn-shadow':'0 4px 24px rgba(0,0,0,0.06)','--upn-sub':'#9ca3af','--upn-badge-bg':'#f5f5f5','--upn-prog-track':'#efefef','--upn-comment-bg':'#f2f2f2','--upn-blur-amount':'0px'},
    bold:      {'--upn-bg':'#ffffff','--upn-border':'#6C3EFF','--upn-shadow':'6px 6px 0 #6C3EFF,0 0 0 2px #6C3EFF','--upn-sub':'#555','--upn-badge-bg':'#f0eeff','--upn-prog-track':'#f0eeff','--upn-comment-bg':'#f5f2ff','--upn-blur-amount':'0px'},
    royal:     {'--upn-bg':'#fffbf0','--upn-accent':'#c9922a','--upn-border':'#e8c87a','--upn-shadow':'0 16px 48px rgba(201,146,42,0.2)','--upn-sub':'#8a6d2f','--upn-badge-bg':'#fef3c7','--upn-prog-track':'#fef3c7','--upn-comment-bg':'#fffbea','--upn-blur-amount':'0px'},
    forest:    {'--upn-bg':'#f0fdf4','--upn-accent':'#16a34a','--upn-border':'#bbf7d0','--upn-shadow':'0 16px 48px rgba(22,163,74,0.13)','--upn-sub':'#4d7a60','--upn-badge-bg':'#dcfce7','--upn-prog-track':'#dcfce7','--upn-comment-bg':'#ecfdf5','--upn-blur-amount':'0px'},
    sunset:    {'--upn-bg':'linear-gradient(135deg,#fff7ed 0%,#fef3c7 100%)','--upn-accent':'#ea580c','--upn-border':'#fed7aa','--upn-shadow':'0 16px 48px rgba(234,88,12,0.15)','--upn-sub':'#92400e','--upn-badge-bg':'#ffedd5','--upn-prog-track':'#ffedd5','--upn-comment-bg':'#fff7ed','--upn-blur-amount':'0px'},
    aurora:    {'--upn-bg':'rgba(10,5,30,0.9)','--upn-border':'rgba(168,85,247,0.4)','--upn-shadow':'0 0 0 1px rgba(168,85,247,0.2),0 24px 64px rgba(124,58,237,0.4)','--upn-accent':'#a78bfa','--upn-accent2':'#38bdf8','--upn-text':'#f0e8ff','--upn-sub':'rgba(200,180,255,0.65)','--upn-badge-bg':'rgba(124,58,237,0.18)','--upn-prog-track':'rgba(167,139,250,0.2)','--upn-comment-bg':'rgba(124,58,237,0.1)','--upn-blur-amount':'0px'},
    neumorphic:{'--upn-bg':'#e0e5ec','--upn-border':'transparent','--upn-shadow':'9px 9px 22px #b8bec7,-7px -7px 18px #ffffff','--upn-sub':'#6b7280','--upn-text':'#374151','--upn-badge-bg':'#e0e5ec','--upn-prog-track':'#c8cdd5','--upn-comment-bg':'#e8ecf2','--upn-blur-amount':'0px'},
    cyberpunk: {'--upn-bg':'#050510','--upn-text':'#f0e040','--upn-border':'rgba(240,224,64,0.8)','--upn-shadow':'0 0 24px rgba(240,224,64,0.25),3px 3px 0 rgba(240,224,64,0.5)','--upn-accent':'#f0e040','--upn-accent2':'#ff4da6','--upn-sub':'rgba(240,224,64,0.5)','--upn-badge-bg':'rgba(240,224,64,0.08)','--upn-prog-track':'rgba(240,224,64,0.12)','--upn-comment-bg':'rgba(240,224,64,0.05)','--upn-blur-amount':'0px'},
    luxury:    {'--upn-bg':'#090909','--upn-text':'#f5f0e8','--upn-border':'rgba(212,175,55,0.3)','--upn-shadow':'0 32px 80px rgba(0,0,0,0.75),inset 0 1px 0 rgba(212,175,55,0.08),0 0 0 1px rgba(212,175,55,0.1)','--upn-accent':'#d4af37','--upn-accent2':'#f0d060','--upn-sub':'rgba(245,240,232,0.4)','--upn-badge-bg':'rgba(212,175,55,0.07)','--upn-prog-track':'rgba(212,175,55,0.1)','--upn-comment-bg':'rgba(212,175,55,0.05)','--upn-blur-amount':'0px'},
    pastel:    {'--upn-bg':'linear-gradient(135deg,#fce4ec 0%,#e8eaf6 50%,#e0f2f1 100%)','--upn-border':'rgba(255,255,255,0.8)','--upn-shadow':'0 16px 40px rgba(180,100,150,0.15)','--upn-accent':'#e91e63','--upn-sub':'#7b6b8d','--upn-badge-bg':'rgba(233,30,99,0.08)','--upn-prog-track':'rgba(233,30,99,0.1)','--upn-comment-bg':'rgba(233,30,99,0.05)','--upn-blur-amount':'0px'},
    ocean:     {'--upn-bg':'linear-gradient(135deg,#0a192f 0%,#112240 100%)','--upn-text':'#ccd6f6','--upn-border':'rgba(100,255,218,0.2)','--upn-shadow':'0 20px 56px rgba(0,0,0,0.5)','--upn-accent':'#64ffda','--upn-accent2':'#57cbff','--upn-sub':'rgba(136,146,176,0.8)','--upn-badge-bg':'rgba(100,255,218,0.07)','--upn-prog-track':'rgba(100,255,218,0.1)','--upn-comment-bg':'rgba(100,255,218,0.04)','--upn-blur-amount':'0px'},
    sakura:    {'--upn-bg':'linear-gradient(135deg,#fff0f3 0%,#ffe4e9 100%)','--upn-border':'rgba(255,182,193,0.6)','--upn-shadow':'0 16px 44px rgba(255,100,130,0.18)','--upn-accent':'#ff4d6d','--upn-accent2':'#ff8fa3','--upn-sub':'rgba(180,80,100,0.65)','--upn-badge-bg':'rgba(255,77,109,0.08)','--upn-prog-track':'rgba(255,77,109,0.1)','--upn-comment-bg':'rgba(255,77,109,0.05)','--upn-blur-amount':'0px'}
  };

  var POS_MAP = {
    bl:{b:'24px',l:'20px',r:'auto',t:'auto'},
    br:{b:'24px',r:'20px',l:'auto',t:'auto'},
    tl:{t:'24px',l:'20px',r:'auto',b:'auto'},
    tr:{t:'24px',r:'20px',l:'auto',b:'auto'},
    bc:{b:'24px',l:'50%',r:'auto',t:'auto',cx:true},
    tc:{t:'24px',l:'50%',r:'auto',b:'auto',cx:true}
  };

  var AIN = {
    slideUp:  {f:'translateY(110%)',  to:'translateY(0)',  e:'cubic-bezier(0.34,1.56,0.64,1)'},
    slideLeft:{f:'translateX(110%)', to:'translateX(0)',  e:'cubic-bezier(0.34,1.56,0.64,1)'},
    fadeZoom: {f:'scale(0.82)',       to:'scale(1)',       e:'cubic-bezier(0.34,1.56,0.64,1)',op0:0},
    bounce:   {f:'scale(0.5)',        to:'scale(1)',       e:'cubic-bezier(0.68,-0.55,0.27,1.55)'},
    flip:     {f:'perspective(600px) rotateX(-90deg)',to:'perspective(600px) rotateX(0)',e:'cubic-bezier(0.34,1.56,0.64,1)'},
    elastic:  {f:'scale(0)',          to:'scale(1)',       e:'cubic-bezier(0.87,-0.41,0.19,1.44)'},
    morphIn:  {f:'scale(0.6) rotate(-8deg)',to:'scale(1) rotate(0)',e:'cubic-bezier(0.34,1.56,0.64,1)'}
  };
  var AOUT = {
    slideDown: {f:'translateY(0)',  to:'translateY(110%)', e:'cubic-bezier(0.55,0,1,0.45)'},
    slideRight:{f:'translateX(0)', to:'translateX(110%)', e:'cubic-bezier(0.55,0,1,0.45)'},
    fadeZoom:  {f:'scale(1)',       to:'scale(0.8)',        e:'ease-in',op0:0},
    shrink:    {f:'scale(1)',       to:'scale(0)',          e:'cubic-bezier(0.55,0,1,0.45)',op0:0}
  };

  var CICONS=['💬','🗣️','💭','🌟','✨','💯','🔥','👏','😍','🎉','❤️','🏆','⭐','🎊','💪','😊','🙌','🎯','💎','🚀','🥰','😎','🤩','💝','🌸','🦋','🎈','🎆','🔮','🌈'];

  /* ═══════════════ BUILD HTML ═══════════════ */
  function buildHTML(cfg) {
    var acc=cfg.accentColor||'#6C3EFF', avS=cfg.avatarSize||58;
    var lang=cfg.labelLanguage||cfg.language||'english';
    var clbl=labelText(cfg.counterLabel,'people are viewing now','log dekh rahe hain',lang);
    return (cfg.showCounter?'<div class="upn-counter-pill" id="upn-ctr"><span class="upn-live-dot"></span><span class="upn-cnum" id="upn-cnum"><span>—</span></span><span class="upn-clbl">'+clbl+'</span></div>':'')+
    '<div class="upn-card" id="upn-card" role="alert" aria-live="assertive" aria-atomic="true">'+
    (cfg.showClose?'<button class="upn-x" id="upn-x" type="button" aria-label="Close"><svg width="9" height="9" viewBox="0 0 9 9" fill="none"><line x1="1" y1="1" x2="8" y2="8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><line x1="8" y1="1" x2="1" y2="8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>':'')+
    (cfg.showSocialStack?'<div class="upn-stack-row" id="upn-stack"><div class="upn-stack-avs" id="upn-savs"></div><span class="upn-stack-text" id="upn-stxt"></span></div>':'')+
    '<div class="upn-body"><div class="upn-main-row">'+
    '<div class="upn-av-wrap'+(cfg.enablePulse?' upn-pulse':'')+'"><div class="upn-av-frame" style="width:'+avS+'px;height:'+avS+'px"><img class="upn-av" id="upn-av" src="" alt="" width="'+avS+'" height="'+avS+'" loading="eager"><div class="upn-av-sh" id="upn-avsh"></div></div>'+
    (cfg.showFlag?'<span class="upn-flag" aria-hidden="true">'+(cfg.flagEmoji||'🇮🇳')+'</span>':'')+
    '</div>'+
    '<div class="upn-content">'+
    '<div class="upn-name-row"><span class="upn-name" id="upn-name">—</span>'+(cfg.showVerified?'<span class="upn-vbadge" title="Verified Buyer">'+badgeSVG(cfg.badgeStyle||'shield',acc)+'</span>':'')+
    '</div>'+
    '<div class="upn-action" id="upn-action">—</div></div></div>'+
    '<a class="upn-prod" id="upn-prod" href="#" target="_blank" rel="noopener noreferrer">'+
    '<img class="upn-prod-img" id="upn-pimg" src="" alt="" width="40" height="40" loading="lazy">'+
    '<div class="upn-prod-info"><div class="upn-prod-name" id="upn-pname">—</div>'+
    '<div class="upn-prod-sub"><span class="upn-prod-price" id="upn-pprice"></span><span class="upn-prod-badge" id="upn-pbadge"></span></div></div>'+
    '<span class="upn-arr">›</span></a>'+
    (cfg.showComment?'<div class="upn-cmnt" id="upn-cmnt"><span class="upn-cico" id="upn-cico">💬</span><span class="upn-ctxt" id="upn-ctxt">—</span></div>':'')+
    (cfg.showUrgency?'<div class="upn-urgency" id="upn-urg"><span class="upn-urg-dot"></span><span id="upn-urgtxt">—</span></div>':'')+
    (cfg.showCountdown?'<div class="upn-countdown" id="upn-cd">⏱️ <span id="upn-cdtxt">—</span></div>':'')+
    '<div class="upn-meta">'+
    (cfg.showRating?'<span class="upn-stars" id="upn-stars"></span>':'')+
    (cfg.showCity?'<span class="upn-city" id="upn-city">—</span>':'')+
    (cfg.showTimeAgo?'<span class="upn-time" id="upn-time">—</span>':'')+
    '</div></div>'+
    (cfg.showProgress?'<div class="upn-prog-track"><div class="upn-prog" id="upn-prog"></div></div>':'')+
    '</div>';
  }

  function injectMobileCriticalCSS(){
    injectCSS('upn-mobile-critical',
      '@media (max-width:767px){'+
      '.upn-root{display:block!important;height:auto!important;min-height:0!important;align-items:flex-start!important;width:min(var(--upn-mobile-width),288px,calc(100vw - 10px))!important;max-width:min(288px,calc(100vw - 10px))!important;}'+
      '.upn-root .upn-card{height:auto!important;min-height:0!important;max-height:min(420px,calc(100svh - 14px))!important;display:flex!important;flex-direction:column!important;align-self:flex-start!important;overflow:hidden!important;}'+
      '.upn-root .upn-body{display:flex!important;flex-direction:column!important;align-items:stretch!important;gap:4px!important;height:auto!important;min-height:0!important;max-height:none!important;overflow-y:visible!important;flex:0 1 auto!important;padding:8px!important;}'+
      '.upn-root .upn-main-row{display:grid!important;grid-template-columns:var(--upn-avatar-size) minmax(0,1fr)!important;column-gap:var(--upn-col-gap)!important;align-items:start!important;width:100%!important;min-width:0!important;}'+
      '.upn-root .upn-av-wrap{grid-column:1!important;grid-row:1!important;}'+
      '.upn-root .upn-content{grid-column:2!important;grid-row:1!important;min-width:0!important;align-self:center!important;}'+
      '.upn-root .upn-prod,.upn-root .upn-cmnt,.upn-root .upn-urgency,.upn-root .upn-countdown,.upn-root .upn-meta{width:100%!important;max-width:100%!important;grid-column:auto!important;grid-row:auto!important;}'+
      '.upn-root .upn-av-wrap,.upn-root .upn-name-row,.upn-root .upn-action,.upn-root .upn-prod,.upn-root .upn-cmnt,.upn-root .upn-urgency,.upn-root .upn-countdown,.upn-root .upn-meta,.upn-root .upn-star,.upn-root .upn-stack-row{opacity:1!important;transform:none!important;animation:none!important;}'+
      '.upn-root .upn-swipe-hint{display:none!important;}'+
      '}'
    );
  }

  /* ═══════════════ UPN CLASS ═══════════════ */
  function UPN(root,cfg) {
    this.root=root; this.cfg=cfg;
    this._vis=false; this._done=false; this._pst=null; this._prem=0;
    this._T={}; this._cnt=0; this._cdi=null;

    if (!this._pageOK()) { root.style.display='none'; return; }
    var mob=w.innerWidth<768;
    if (mob&&!cfg.enableMobile)  { root.style.display='none'; return; }
    if (!mob&&!cfg.enableDesktop){ root.style.display='none'; return; }
    this._rm = w.matchMedia&&w.matchMedia('(prefers-reduced-motion:reduce)').matches;
    this._injectKF();
    injectMobileCriticalCSS();
    if (cfg.customCSS) injectCSS('upn-custom',cfg.customCSS);
    root.innerHTML=buildHTML(cfg);
    this._applyPreset();
    this._positionRoot();
    var q=function(s){ return root.querySelector(s); };
    this.card=q('#upn-card'); this.body=q('.upn-body'); this.mainRow=q('.upn-main-row'); this.av=q('#upn-av'); this.avsh=q('#upn-avsh');
    if(this.card){
      this.card.style.setProperty('height','auto','important');
      this.card.style.setProperty('min-height','0','important');
    }
    if(this.body){
      this.body.style.setProperty('display','flex','important');
      this.body.style.setProperty('flex-direction','column','important');
      this.body.style.setProperty('flex','0 1 auto','important');
      this.body.style.setProperty('height','auto','important');
      this.body.style.setProperty('min-height','0','important');
    }
    this.nEl=q('#upn-name'); this.aEl=q('#upn-action');
    this.prod=q('#upn-prod'); this.pimg=q('#upn-pimg');
    this.pname=q('#upn-pname'); this.pprice=q('#upn-pprice'); this.pbadge=q('#upn-pbadge');
    this.cmnt=q('#upn-ctxt'); this.cico=q('#upn-cico');
    this.stars=q('#upn-stars'); this.city=q('#upn-city'); this.time=q('#upn-time');
    this.prog=q('#upn-prog'); this.cnumEl=q('#upn-cnum');
    this.urgEl=q('#upn-urgtxt'); this.cdEl=q('#upn-cdtxt');
    this.savs=q('#upn-savs'); this.stxt=q('#upn-stxt');

    if (this.card) this.card.style.cssText+=';visibility:hidden;opacity:0;pointer-events:none;transform:translateY(110%);will-change:transform,opacity;';

    var lang=cfg.labelLanguage||cfg.language||'english';
    var commentLang=cfg.commentLanguage||'mixed';
    var commentFallback=commentLang==='english'?COMMENTS_EN:(commentLang==='hinglish'?COMMENTS_HI:COMMENTS_HI.concat(COMMENTS_EN));
    var names=parseLines(cfg.customNames,NAMES);
    this._rN=new SR(names);
    this._rC=new SR(parseLines(cfg.customCities,CITIES));
    var actionFallback=lang==='hinglish'?ACTIONS_HI:ACTIONS_EN;
    var actionLines=parseLines(cfg.customActions,[]);
    if(!actionLines.length || (lang!=='hinglish' && actionLines.some(hasHinglishWords))) actionLines=actionFallback;
    this._rA=new SR(actionLines);
    this._rCom=new SR(parseLines(cfg.customComments,commentFallback));
    this._rT=new SR(lang==='hinglish'?TIMES_HI:TIMES_EN);

    var prods=cfg.products&&cfg.products.length?cfg.products.slice():[];
    if (cfg.currentProduct) prods.unshift(cfg.currentProduct,cfg.currentProduct,cfg.currentProduct);
    this._rP=prods.length?new SR(prods):null;

    var self=this;
    var xb=q('#upn-x');
    if (xb) xb.addEventListener('click',function(){self._dismiss();});
    if (this.card) {
      this.card.addEventListener('mouseenter',function(){self._pause();});
      this.card.addEventListener('mouseleave',function(){self._resume();});
      this._initSwipe();
    }
    if (this.prod&&cfg.enableTracking) {
      this.prod.addEventListener('click',function(){
        var p=self._lastProd;
        try{if(w.dataLayer)w.dataLayer.push({event:'upn_product_click',upn_title:p&&p.title,upn_id:p&&p.id});if(typeof gtag==='function')gtag('event','upn_click',{product_title:p&&p.title});}catch(e){}
      });
    }
    if (cfg.showCounter&&this.cnumEl) this._initCtr();
    this._applyHeaderOffset();
    this._resizeH=function(){self._positionRoot();self._applyHeaderOffset();};
    w.addEventListener('resize',this._resizeH,{passive:true});
    w.addEventListener('orientationchange',this._resizeH,{passive:true});
    if (cfg.exitIntent) this._exitIntent();
    else if (cfg.scrollTrigger) this._scrollTrig();
    else this._T.next=setTimeout(function(){self._show();},cfg.initDelay||4000);
  }

  UPN.prototype._pageOK=function(){
    var c=this.cfg, tmpl=w.__UPN_TEMPLATE__||'';
    if(tmpl==='index'&&!c.pageHome) return false;
    if(tmpl==='product'&&!c.pageProduct) return false;
    if(tmpl==='collection'&&!c.pageCollection) return false;
    if(tmpl==='cart'&&!c.pageCart) return false;
    if((tmpl==='blog'||tmpl==='article')&&!c.pageBlog) return false;
    if(tmpl==='search'&&!c.pageSearch) return false;
    if(tmpl==='page'&&!c.pageCms) return false;
    return true;
  };

  UPN.prototype._applyPreset=function(){
    var c=this.cfg, base=PRESETS[c.style]||PRESETS.glass, r=this.root;
    for(var k in base){if(base.hasOwnProperty(k))r.style.setProperty(k,base[k]);}
    r.style.setProperty('--upn-accent',c.accentColor||base['--upn-accent']||'#6C3EFF');
    r.style.setProperty('--upn-accent2',base['--upn-accent2']||c.accentColor||'#a78bfa');
    r.style.setProperty('--upn-text',base['--upn-text']||c.textColor||'#0f0f1a');
    r.style.setProperty('--upn-radius',(c.borderRadius||20)+'px');
    r.style.setProperty('--upn-width',(c.width||360)+'px');
    r.style.setProperty('--upn-mobile-width',(c.mobileWidth||288)+'px');
    r.style.setProperty('--upn-max-height',(c.maxHeight&&c.maxHeight>0)?(c.maxHeight+'px'):'min(720px, calc(100svh - 24px))');
    r.style.setProperty('--upn-avatar-size',(c.avatarSize||58)+'px');
    r.style.setProperty('--upn-mobile-avatar-size',(c.mobileAvatarSize||38)+'px');
    if(c.fontFamily)r.style.setProperty('--upn-font',c.fontFamily);
    if(c.blurAmount!=null)r.style.setProperty('--upn-blur-amount',c.blurAmount+'px');
    r.setAttribute('data-upn-style',c.style||'glass');
    r.setAttribute('data-upn-density',c.density||'auto');
    if(c.autoDark)r.setAttribute('data-upn-auto-dark','true');
    if(c.rtl)r.setAttribute('dir','rtl');
  };

  UPN.prototype._positionRoot=function(){
    var c=this.cfg, pos=POS_MAP[c.position]||POS_MAP.bl;
    var mob=w.innerWidth<768;
    var ox=(mob?(c.mobileOffsetX||8):(c.offsetX||20))+'px';
    var oy=(mob?(c.mobileOffsetY||12):(c.offsetY||24))+'px';
    var r=this.root;
    r.style.position='fixed';
    r.style.zIndex='2147483640';
    r.style.top=pos.t||'auto'; r.style.bottom=pos.b||'auto';
    r.style.left=pos.cx?'50%':(pos.l!=='auto'?ox:'auto');
    r.style.right=pos.r!=='auto'?ox:'auto';
    r.style.transform=pos.cx?'translateX(-50%)':'none';
    if(pos.b&&pos.b!=='auto')r.style.bottom=oy;
    if(pos.t&&pos.t!=='auto')r.style.top=oy;
    r.style.setProperty('height','auto','important');
    r.style.setProperty('min-height','0','important');
    r.style.alignItems='flex-start';
    r.style.maxWidth=mob?'min(288px, calc(100vw - 10px))':'calc(100vw - 16px)';
    r.style.width=mob?'min(var(--upn-mobile-width), 288px, calc(100vw - 10px))':'min(var(--upn-width), calc(100vw - 16px))';
  };

  UPN.prototype._applyHeaderOffset=function(){
    if(!this.cfg.dawnHeaderOffset)return;
    var h=d.querySelector('.shopify-section-header-sticky,.header-wrapper,header.header');
    if(!h)return;
    var ht=h.offsetHeight; if(!ht)return;
    var pos=this.cfg.position||'bl';
    if(pos==='tl'||pos==='tr'||pos==='tc'){
      var cur=parseInt(this.root.style.top)||this.cfg.offsetY||24;
      this.root.style.top=(cur+ht+8)+'px';
    }
  };

  UPN.prototype._initCtr=function(){
    var c=this.cfg, self=this;
    this._lc=ri(c.counterMin||40,c.counterMax||240);
    this._updCtr();
    this._T.ctr=setInterval(function(){
      self._lc=Math.max(c.counterMin||40,Math.min(c.counterMax||240,self._lc+ri(-10,16)));
      self._updCtr();
    },(c.counterInterval||10)*1000);
  };
  UPN.prototype._updCtr=function(){
    if(!this.cnumEl)return;
    var sp=d.createElement('span');
    sp.textContent=this._lc.toLocaleString('en-IN');
    sp.style.cssText='display:inline-block;animation:upn-slot-flip .35s cubic-bezier(0.34,1.56,0.64,1) both';
    this.cnumEl.innerHTML=''; this.cnumEl.appendChild(sp);
  };

  UPN.prototype._rec=function(){
    return {
      name:this._rN.next(),city:this._rC.next(),action:this._rA.next(),
      comment:this._rCom.next(),time:this._rT.next(),
      rating:[4,4,4,4,5,5,5][ri(0,6)],
      product:this._rP?this._rP.next():null
    };
  };

  UPN.prototype._loadAv=function(name){
    if(!this.av)return;
    if(this.avsh)this.avsh.style.opacity='1';
    var av=this.av,avsh=this.avsh,urls=getAvatarUrls(name,this.cfg.avatarStyle);
    function tryNext(i){
      if(i>=urls.length){if(avsh)avsh.style.opacity='0';return;}
      var img=new Image();
      img.onload=function(){av.src=urls[i];av.alt=name;if(avsh)avsh.style.opacity='0';};
      img.onerror=function(){tryNext(i+1);};
      img.src=urls[i];
    }
    tryNext(0);
  };

  UPN.prototype._renderStack=function(mainName){
    if(!this.savs||!this.stxt)return;
    var names=[],n,i;
    for(i=0;i<5;i++){n=this._rN.next();if(n!==mainName)names.push(n);}
    var html='';
    for(i=0;i<Math.min(3,names.length);i++){
      var u=getAvatarUrls(names[i],'realistic_auto');
      html+='<img src="'+u[0]+'" alt="'+names[i]+'" width="22" height="22" style="width:22px;height:22px;border-radius:50%;object-fit:cover;border:2px solid #fff;margin-left:'+(i>0?'-8px':'0')+';" onerror="this.src=\''+u[1]+'\'">';
    }
    this.savs.innerHTML=html;
    var ex=ri(4,19), lang=this.cfg.labelLanguage||this.cfg.language||'english';
    var fn=names[0]?names[0].split(' ')[0]:'Kuch';
    this.stxt.textContent=lang==='hinglish'?fn+' +'+ex+' logon ne bhi liya':fn+' +'+ex+' others also bought';
  };

  UPN.prototype._render=function(rec){
    var c=this.cfg, lang=c.labelLanguage||c.language||'english';
    this._loadAv(rec.name);
    if(this.nEl)this.nEl.textContent=rec.name;
    if(this.aEl)this.aEl.textContent=rec.name+' '+rec.action;
    this._lastProd=rec.product;
    if(rec.product){
      if(this.pname)this.pname.textContent=rec.product.title||'—';
      if(this.pprice)this.pprice.textContent=rec.product.price||'';
      if(this.prod){this.prod.href=rec.product.url||'#';this.prod.style.pointerEvents=rec.product.url?'auto':'none';}
      if(this.pimg&&rec.product.image){this.pimg.src=rec.product.image;this.pimg.alt=rec.product.title||'';this.pimg.style.display='block';this.pimg.onerror=function(){this.style.display='none';};}
      else if(this.pimg)this.pimg.style.display='none';
      if(this.pbadge){var badge=rec.product.scarcity||(c.showScarcity?(lang==='hinglish'?'🔥 Hot item':'🔥 Hot'):'');if(badge){this.pbadge.textContent=badge;this.pbadge.style.display='inline';}else this.pbadge.style.display='none';}
    } else {
      if(this.pimg)this.pimg.style.display='none';
      if(this.pname)this.pname.textContent=lang==='hinglish'?'🔥 Ek popular item':'🔥 Popular item';
      if(this.pprice)this.pprice.textContent='';
      if(this.prod)this.prod.href='#';
      if(this.pbadge)this.pbadge.style.display='none';
    }
    if(this.cmnt){this.cmnt.textContent=rec.comment;if(this.cico)this.cico.textContent=CICONS[ri(0,CICONS.length-1)];}
    if(this.urgEl&&c.showUrgency){var vc=ri(c.urgencyMin||18,c.urgencyMax||94);this.urgEl.textContent='🔥 '+vc+' '+labelText(c.urgencyLabel,'people viewing this now','log abhi yeh dekh rahe hain',lang);}
    if(this.cdEl&&c.showCountdown&&c.countdownEnd)this._startCD(c.countdownEnd);
    if(this.stars)this.stars.innerHTML=starsHTML(rec.rating);
    if(this.city)this.city.textContent='📍 '+rec.city;
    if(this.time)this.time.textContent='🕐 '+rec.time;
    if(c.showSocialStack)this._renderStack(rec.name);
    if(this.prog){this.prog.style.transition='none';this.prog.style.width='100%';}
  };

  UPN.prototype._startCD=function(end){
    var self=this,el=this.cdEl,lang=this.cfg.labelLanguage||this.cfg.language||'english';
    if(this._cdi)clearInterval(this._cdi);
    function tick(){
      var r=new Date(end)-new Date();
      if(r<=0){el.textContent=lang==='hinglish'?'Sale khatam!':'Sale ended!';clearInterval(self._cdi);return;}
      var totalSeconds=Math.floor(r/1000);
      var dLeft=Math.floor(totalSeconds/86400);
      var h=Math.floor((totalSeconds%86400)/3600);
      var m=Math.floor((totalSeconds%3600)/60);
      var s=totalSeconds%60;
      var prefix=lang==='hinglish'?'Sale ends in ':'Sale ends in ';
      if(dLeft>0){
        el.textContent=prefix+dLeft+'d '+h+'h';
      }else if(h>0){
        el.textContent=prefix+('0'+h).slice(-2)+'h '+('0'+m).slice(-2)+'m';
      }else{
        el.textContent=prefix+('0'+m).slice(-2)+'m '+('0'+s).slice(-2)+'s';
      }
    }
    tick();this._cdi=setInterval(tick,1000);
  };

  UPN.prototype._animIn=function(key,cb){
    var el=this.card; if(!el)return cb&&cb();
    if(this._rm){el.style.cssText+=';visibility:visible;opacity:1;pointer-events:all;transform:none;transition:none;';el.classList.add('upn-visible');return cb&&cb();}
    var a=AIN[key]||AIN.slideUp;
    var op0=(a.op0!==undefined)?String(a.op0):'1';
    el.style.cssText+=';visibility:visible;pointer-events:all;transform:'+a.f+';opacity:'+op0+';transition:none;';
    requestAnimationFrame(function(){requestAnimationFrame(function(){
      el.style.transition='transform .5s '+a.e+',opacity .38s ease';
      el.style.transform=a.to; el.style.opacity='1';
      setTimeout(function(){el.classList.add('upn-visible');if(cb)cb();},120);
    });});
  };

  UPN.prototype._animOut=function(key,cb){
    var el=this.card; el.classList.remove('upn-visible');
    if(this._rm){el.style.visibility='hidden';el.style.pointerEvents='none';return cb&&cb();}
    var a=AOUT[key]||AOUT.slideDown;
    el.style.transition='transform .36s '+a.e+',opacity .28s ease';
    el.style.transform=a.to;
    if(a.op0!==undefined)el.style.opacity=String(a.op0);
    setTimeout(function(){el.style.visibility='hidden';el.style.pointerEvents='none';el.style.willChange='auto';if(cb)cb();},400);
  };

  UPN.prototype._show=function(){
    if(this._done)return;
    var cap=this.cfg.sessionCap||0;
    if(cap&&this._cnt>=cap){this._dismiss();return;}
    this._cnt++;
    var rec=this._rec(); this._render(rec);
    if(this.cfg.enableSound)playChime();
    try{if(this.cfg.enableHaptic&&navigator.vibrate)navigator.vibrate([30]);}catch(e){}
    var self=this;
    this._animIn(this.cfg.animIn||'slideUp',function(){
      self._vis=true; self._startProg();
      self._T.show=setTimeout(function(){self._hide();},self.cfg.duration||7000);
    });
  };

  UPN.prototype._startProg=function(){
    if(!this.prog)return;
    var dur=this.cfg.duration||7000; this._prem=dur; var p=this.prog;
    requestAnimationFrame(function(){requestAnimationFrame(function(){p.style.transition='width '+dur+'ms linear';p.style.width='0%';});});
  };

  UPN.prototype._pause=function(){
    if(!this._vis||this._pst!=null)return;
    this._pst=Date.now(); clearTimeout(this._T.show);
    if(this.prog){var c=parseFloat(getComputedStyle(this.prog).width),t=this.prog.parentElement?this.prog.parentElement.offsetWidth:360;this._prem=(c/(t||360))*(this.cfg.duration||7000);this.prog.style.transition='none';this.prog.style.width=((c/(t||360))*100)+'%';}
  };

  UPN.prototype._resume=function(){
    if(this._pst==null||this._done)return;
    this._pst=null; var rem=Math.max(500,this._prem),p=this.prog,self=this;
    if(p)requestAnimationFrame(function(){requestAnimationFrame(function(){p.style.transition='width '+rem+'ms linear';p.style.width='0%';});});
    this._T.show=setTimeout(function(){self._hide();},rem);
  };

  UPN.prototype._hide=function(){
    if(!this._vis)return; this._vis=false; clearTimeout(this._T.show);
    var self=this, cfg=this.cfg;
    this._animOut(cfg.animOut||'slideDown',function(){
      if(!self._done&&cfg.loop!==false){
        var gap=ri(cfg.intervalMin||7000,cfg.intervalMax||15000);
        self._T.next=setTimeout(function(){self._show();},gap);
      }
    });
  };

  UPN.prototype._dismiss=function(){
    this._done=true;
    var T=this._T;
    Object.keys(T).forEach(function(k){clearTimeout(T[k]);clearInterval(T[k]);});
    if(this._cdi)clearInterval(this._cdi);
    if(this._exitH)d.removeEventListener('mouseleave',this._exitH);
    if(this._scrollH)w.removeEventListener('scroll',this._scrollH);
    if(this._resizeH){w.removeEventListener('resize',this._resizeH);w.removeEventListener('orientationchange',this._resizeH);}
    var self=this;
    this._animOut(this.cfg.animOut||'slideDown',function(){
      var ctr=self.root.querySelector('#upn-ctr');
      if(ctr)ctr.style.display='none';
    });
  };

  UPN.prototype._initSwipe=function(){
    var self=this,card=this.card,sx=0,sy=0,drag=false;
    card.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;sy=e.touches[0].clientY;drag=true;self._pause();},{passive:true});
    card.addEventListener('touchmove',function(e){
      if(!drag)return;
      var dx=e.touches[0].clientX-sx,dy=e.touches[0].clientY-sy;
      if(Math.abs(dx)>Math.abs(dy)&&Math.abs(dx)>10){card.style.transform='translateX('+dx+'px)';card.style.opacity=String(1-Math.abs(dx)/200);}
    },{passive:true});
    card.addEventListener('touchend',function(e){
      if(!drag)return;drag=false;
      var dx=e.changedTouches[0].clientX-sx;
      if(Math.abs(dx)>80){card.style.transition='transform .28s ease,opacity .28s ease';card.style.transform='translateX('+(dx>0?'130%':'-130%')+')';card.style.opacity='0';setTimeout(function(){self._dismiss();},300);}
      else{card.style.transition='transform .3s cubic-bezier(0.34,1.56,0.64,1),opacity .3s ease';card.style.transform='translateX(0)';card.style.opacity='1';self._resume();}
    },{passive:true});
  };

  UPN.prototype._exitIntent=function(){
    var self=this,fired=false;
    this._exitH=function(e){if(fired||e.clientY>5)return;fired=true;self._show();d.removeEventListener('mouseleave',self._exitH);};
    d.addEventListener('mouseleave',this._exitH);
  };

  UPN.prototype._scrollTrig=function(){
    var self=this,fired=false,pct=(this.cfg.scrollTriggerPct||25)/100;
    if(w.IntersectionObserver){
      var sen=d.createElement('div');
      sen.style.cssText='position:absolute;top:'+Math.round(pct*100)+'%;height:1px;width:1px;left:0;pointer-events:none;';
      d.body.appendChild(sen);
      var obs=new IntersectionObserver(function(en){
        if(fired||!en[0].isIntersecting)return;
        fired=true;obs.disconnect();
        try{sen.remove();}catch(e){}
        setTimeout(function(){self._show();},self.cfg.initDelay||1000);
      });
      obs.observe(sen);
    } else {
      this._scrollH=function(){
        if(fired)return;
        var sc=w.scrollY/((d.body.scrollHeight-w.innerHeight)||1);
        if(sc>=pct){fired=true;w.removeEventListener('scroll',self._scrollH);setTimeout(function(){self._show();},self.cfg.initDelay||1000);}
      };
      w.addEventListener('scroll',this._scrollH,{passive:true});
    }
  };

  UPN.prototype._injectKF=function(){
    injectCSS('upn-kf',
      '@keyframes upn-dot{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.3;transform:scale(.65)}}'+
      '@keyframes upn-slot-flip{0%{transform:translateY(-100%);opacity:0}100%{transform:translateY(0);opacity:1}}'+
      '@keyframes upn-pill{0%{transform:translateY(-10px) scale(.9);opacity:0}100%{transform:translateY(0) scale(1);opacity:1}}'+
      '@keyframes upn-badge{0%{transform:scale(.3) rotate(-15deg);opacity:0}65%{transform:scale(1.18) rotate(4deg)}85%{transform:scale(.97)}100%{transform:scale(1) rotate(0);opacity:1}}'+
      '@keyframes upn-shine{0%,100%{filter:drop-shadow(0 0 2px rgba(255,215,0,.35))}50%{filter:drop-shadow(0 0 8px rgba(255,215,0,.9))}}'+
      '@keyframes upn-shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}'+
      '@keyframes upn-pulse{0%{box-shadow:0 0 0 2.5px #fff,0 0 0 4px var(--upn-accent),0 0 0 4px rgba(108,62,255,.5),0 6px 18px rgba(0,0,0,.2)}70%{box-shadow:0 0 0 2.5px #fff,0 0 0 4px var(--upn-accent),0 0 0 15px rgba(108,62,255,0),0 6px 18px rgba(0,0,0,.2)}100%{box-shadow:0 0 0 2.5px #fff,0 0 0 4px var(--upn-accent),0 0 0 4px rgba(108,62,255,0),0 6px 18px rgba(0,0,0,.2)}}'+
      '@keyframes upn-pop{0%{opacity:0;transform:scale(.7) translateY(8px)}70%{transform:scale(1.05) translateY(-2px)}100%{opacity:1;transform:scale(1) translateY(0)}}'+
      '@keyframes upn-slide{0%{opacity:0;transform:translateY(8px)}100%{opacity:1;transform:translateY(0)}}'+
      '@keyframes upn-star{0%{opacity:0;transform:scale(.4) rotate(-20deg)}70%{transform:scale(1.35) rotate(5deg)}100%{opacity:1;transform:scale(1) rotate(0)}}'+
      '@keyframes upn-aurora{0%,100%{background-position:0% 50%}50%{background-position:100% 50%}}'
    );
  };

  /* ═══════════════ BOOT ═══════════════ */
  function boot(){
    if(!w.__UPN__)return;
    var cfg=w.__UPN__, mount=d.getElementById(cfg.sid);
    if(!mount||mount._upnDone)return;
    mount._upnDone=true;
    mount._upnInst=new UPN(mount,cfg);
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',boot);
  else boot();
  d.addEventListener('shopify:section:load',function(){setTimeout(boot,50);});
  d.addEventListener('shopify:section:reorder',function(){setTimeout(boot,50);});

}(window,document));
